import React from 'react';
import { Paper } from '@mui/material';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { PieChart } from 'echarts/charts';
import { GridComponent, GraphicComponent, TooltipComponent, TitleComponent, LegendComponent } from 'echarts/components';
import { SVGRenderer } from 'echarts/renderers';
import { get, isEqual, size, upperFirst } from 'lodash';

import { isMobile } from '../../../common/services/isMobile';
import ChartHeader from './ChartHeader/ChartHeader';

// http://gallery.echartsjs.com/editor.html?c=xSJZsKhK8g piechart with icon

const getDefaultOptions = ({ data, icon, total }) => ({
  legend: {
    show: true,
    icon: 'circle',
    bottom: 0,
    padding: [20, 0, 0, 0],
    left: 'center',
    textStyle: {
      color: 'black',
      fontFamily: 'Roboto',
      fontSize: 12,
    },
    formatter: (name) =>
      `${name} (${get(
        data.find((i) => i.name === name),
        'value',
        0,
      )})`,
  },
  graphic: {
    elements: [
      {
        type: 'image',
        style: {
          image: icon,
          width: 32,
          height: 32,
          cursor: 'default',
        },
        left: 'center',
        top: '105',
      },
    ],
  },
  tooltip: {
    trigger: 'item',
    formatter: ' {b} <br/> {c} ({d}%)',
    confine: isMobile,
  },
  series: [
    {
      type: 'pie',
      radius: ['50%', '75%'],
      center: ['50%', '120'],
      data: [],
      label: {
        show: false,
        fontSize: 14,
        formatter(param) {
          return `${param.name}:\n${param.value} of ${total}`;
        },
      },
      labelLine: {
        show: false,
      },

      animationType: 'scale',
      animationEasing: 'elasticOut',
      animationDelay(idx) {
        return Math.random() * 200;
      },
    },
  ],
});

const chartsStyle = { width: '100%', height: 310 };

echarts.use([
  TitleComponent,
  GraphicComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  PieChart,
  SVGRenderer,
]);

const PieChartComponent = ({ title, total, data, icon, chartEvents }) => {
  const option = getDefaultOptions({ total, data, icon });
  const legendColors = size(data) ? data.map((item) => item.color) : null;
  const chartsData = size(data)
    ? data.map((item) => {
        item.name = upperFirst(item.name);

        return item;
      })
    : [];

  if (legendColors) option.color = legendColors;
  option.series[0].data = chartsData;

  return (
    <Paper className="chart__paper">
      <ChartHeader>
        <h2>{title}</h2>
        <div className="total__count">{`total ${total}`}</div>
      </ChartHeader>
      <ReactEChartsCore
        onEvents={chartEvents}
        echarts={echarts}
        style={chartsStyle}
        notMerge
        silent
        lazyUpdate
        option={option}
      />
    </Paper>
  );
};

export default React.memo(
  PieChartComponent,
  (prevProps, nextProps) =>
    isEqual(prevProps.title, nextProps.title) &&
    isEqual(prevProps.total, nextProps.total) &&
    isEqual(prevProps.data, nextProps.data) &&
    isEqual(prevProps.icon, nextProps.icon),
);
